import React from "react";
import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, description, className = "" }) => (
  <Reveal className={`max-w-2xl ${className}`}>
    {eyebrow && (
      <p className="eyebrow flex items-center gap-3 text-ivory/70" data-testid="section-eyebrow">
        <span className="inline-block h-px w-8 bg-ivory/40" />
        {eyebrow}
      </p>
    )}
    <h2 className="mt-5 font-serif text-4xl sm:text-5xl leading-[1.05] tracking-tight text-balance text-ivory">
      {title}
    </h2>
    {description && (
      <p className="mt-5 text-base leading-relaxed text-ivory/65">
        {description}
      </p>
    )}
  </Reveal>
);
